import { isEmpty } from 'remeda'
import type { getBreadcrumbs } from '@apps/FooterApp'
import { ChevronRightIcon } from '@velasca/icons/chevronRight'
import { SansText } from '@velasca/ui/sans-text'
import { formatMenuTitle } from '@velasca/utils/format-menu-title'
import { BreadcrumbsList } from './BreadcrumbsHeader.styles'

export const BreadcrumbsHeader = ({
  breadcrumbs,
}: {
  breadcrumbs: ReturnType<typeof getBreadcrumbs>
}) => {
  if (!breadcrumbs || isEmpty(breadcrumbs)) {
    return
  }

  return (
    <nav>
      <BreadcrumbsList>
        {[{ text: 'Home', link: '/' }, ...breadcrumbs].map(
          ({ text, link }, i) => {
            const { sanitizedTitle: sanitizedText } = formatMenuTitle(text)
            const isLast = i === breadcrumbs.length

            return (
              <li key={text}>
                {link && (
                  <SansText
                    fontWeight={isLast ? '500' : '400'}
                    as={!isLast && link !== '#' ? 'a' : 'span'}
                    style={{
                      whiteSpace: 'nowrap',
                    }}
                    {...(!isLast && link !== '#' ? { href: link } : {})}
                    {...(isLast ? { 'aria-current': 'page' } : {})}
                  >
                    {sanitizedText}
                  </SansText>
                )}
                {!isLast && <ChevronRightIcon />}
              </li>
            )
          },
        )}
      </BreadcrumbsList>
    </nav>
  )
}
